import type { IFramework } from '@/framework';

/**
 * 设置 Text Editor 期间的基础操作禁用状态
 *
 * 该方法会同步更新 Framework Editor 的移动、缩放、旋转和尺寸调整开关。
 *
 * @param framework - 当前编辑器 Framework
 * @param disabled - 是否禁用基础操作
 * @returns 无返回值
 */
export const setBaseOperationsDisabled = (framework: IFramework, disabled: boolean): void => {
    const editor = framework.service.editor;
    editor.setDisableMove(disabled);
    editor.setDisableScale(disabled);
    editor.setDisableRotate(disabled);
    editor.setDisableResize(disabled);
};
